import { render } from "./ResultadosValidacaoFuncionalidade.vue?vue&type=template&id=5229cbb8"
import script from "./ResultadosValidacaoFuncionalidade.vue?vue&type=script&lang=js"
export * from "./ResultadosValidacaoFuncionalidade.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__